import script from "./RegistComplete.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegistComplete.vue?vue&type=script&lang=ts&setup=true"

import "./RegistComplete.vue?vue&type=style&index=0&id=d1ca92aa&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1ca92aa"]])

export default __exports__